interface RenderSwitchProps {
	[key: string]: boolean | number | string | undefined
	checked?: boolean
	id: string
	label: string
	labelPrefix?: string
	labelSuffix?: string
}

export function renderSwitch(props: RenderSwitchProps): string {
	const {
		checked = false,
		id,
		label,
		labelPrefix = '',
		labelSuffix = '',
		...otherProps
	} = props

	const otherAttributes = Object.entries(otherProps)
		.map(([key, value]) => `${key}="${value}"`)
		.join(' ')

	return `
        <div class="tt-switch">
            <div class="tt-switch-label-row">
				${labelPrefix}
				<div class="tt-switch-label-line">
					<label class="tt-switch-label" for="${id}">${label}</label>
					${labelSuffix}
				</div>
            </div>
            <input
                ${otherAttributes}
                type="checkbox"
                id="${id}"
                ${checked ? 'checked' : ''}
            />
            <label class="tt-switch-control" for="${id}"></label>
        </div>
    `
}
